import { Typography } from '@material-ui/core'
import {
  PaginationContainer,
  RowsSelect,
  IconButton,
} from './TablePagination.style'
import { usePagination } from './TablePagination.utils'
import { DEFAULT_NAMESPACE } from 'config/i18n'
import { useTranslation } from 'react-i18next'
import { TablePaginationProps } from './TablePagination.types'

const TablePagination = (props: TablePaginationProps) => {
  const { t } = useTranslation(DEFAULT_NAMESPACE)
  const { paginationInfoString, options, PaginationIconButtons } =
    usePagination(props)
  const { setPageSize, pageSize } = props

  return (
    <PaginationContainer>
      <Typography>{t('rowsOnPage')}</Typography>
      <RowsSelect
        options={options}
        value={[pageSize]}
        handleChange={([value]) => setPageSize(value as number)}
      />
      <Typography>{paginationInfoString}</Typography>
      {PaginationIconButtons.map(({ Icon, isDisabled, onClick, id }, idx) => (
        <IconButton
          key={`pagination-button-${idx}`}
          disabled={isDisabled}
          onClick={onClick}
          id={`${id}-btn`}
        >
          <Icon />
        </IconButton>
      ))}
    </PaginationContainer>
  )
}

export default TablePagination
